<template>
  <Transition name="resumo">
    <div v-show="!mostraCamposCenario" class="resumo">
      <div class="resumo-titulo">
        <p>Cenário: {{ dadosForm.nomeCenario }}</p>
        <p>Termo Pesquisado: {{ dadosForm.termoPesquisado }}</p>
      </div>
      <Registro class="resumo-registro">
        <div class="bloco1">
          <Descricao
            v-b-tooltip.hover.top
            :title="dadosResumo.ncmDescricao"
            class="resumo-descricao"
            tipo="resumo"
            :titulo="dadosResumo.ncm"
            :descricao="dadosResumo.ncmDescricao"
          />
          <Descricao
            class="resumo-descricao"
            tipo="resumo"
            titulo="Tipo da Operação"
            :descricao="dadosResumo.tipoOperacao"
          />
          <Descricao
            class="resumo-descricao"
            tipo="resumo"
            titulo="UF Origem"
            :descricao="dadosResumo.ufOrigem"
          />
          <Descricao
            class="resumo-descricao"
            tipo="resumo"
            titulo="UF Destino"
            :descricao="dadosResumo.ufDestino"
          />
          <Descricao
            class="resumo-descricao"
            tipo="resumo"
            titulo="Atividade do Remetente"
            :descricao="dadosResumo.atividadeRemetente"
          />
          <Descricao
            class="resumo-descricao"
            tipo="resumo"
            titulo="País Origem"
            :descricao="dadosResumo.paisOrigem"
          />
          <Descricao
            class="resumo-descricao"
            tipo="resumo"
            titulo="Atividade do Destinatário"
            :descricao="dadosResumo.atividadeDestino"
          />
          <Descricao
            class="resumo-descricao"
            tipo="resumo"
            titulo="Origem da Mercadoria"
            :descricao="dadosResumo.origem"
          />
          <Descricao
            class="resumo-descricao"
            tipo="resumo"
            titulo="País Destino"
            :descricao="dadosResumo.paisDestino"
          />
          <Descricao
            class="resumo-descricao"
            tipo="resumo"
            titulo="Destinação"
            :descricao="dadosResumo.destinacao"
          />
        </div>
      </Registro>
    </div>
  </Transition>
</template>

<script>
import Descricao from "@/components/Descricao/Descricao.vue";
import Registro from "@/components/Registro/Registro.vue";
import { mapGetters } from "vuex";
import filtros from "@/store/modules/cenarioFiltros.js";

export default {
  name: "Resumo",
  data() {
    return { filtros };
  },
  props: {
    dadosForm: Array | Object,
    mostraCamposCenario: Boolean
  },
  components: { Descricao, Registro },
  computed: {
    ...mapGetters("cenario", ["getFiltros"]),
    dadosResumo() {
      let dados = {
        tipoOperacao: this.dadosForm.tipoOperacao
          ? this.trocaValorNome(this.dadosForm.tipoOperacao, this.filtros.local.valores)
          : null,
        ufOrigem: this.dadosForm.ufOrigem
          ? this.trocaValorNome(this.dadosForm.ufOrigem, this.filtros.estado_origem.valores)
          : null,
        ufDestino: this.dadosForm.ufDestino
          ? this.trocaValorNome(this.dadosForm.ufDestino, this.filtros.estado_destino.valores)
          : null,
        paisOrigem: this.dadosForm.paisOrigem
          ? this.trocaValorNome(this.dadosForm.paisOrigem, this.filtros.pais_origem.valores)
          : null,
        paisDestino: this.dadosForm.paisDestino
          ? this.trocaValorNome(this.dadosForm.paisDestino, this.filtros.pais_destino.valores)
          : null,
        atividadeRemetente: this.dadosForm.atividadeRemetente
          ? this.trocaValorNome(this.dadosForm.atividadeRemetente, this.filtros.atividade.valores)
          : null,
        atividadeDestino: this.dadosForm.atividadeDestino
          ? this.trocaValorNome(this.dadosForm.atividadeDestino, this.filtros.atividade.valores)
          : null,
        origem: this.dadosForm.origem
          ? this.trocaValorNome(this.dadosForm.origem, this.filtros.origem_mercadoria.valores)
          : null,
        destinacao: this.dadosForm.destinacao
          ? this.trocaValorNome(this.dadosForm.destinacao, this.filtros.destinacao.valores)
          : null,
        ncm: this.dadosForm.ncm ? this.dadosForm.ncm : null,
        ncmDescricao: this.dadosForm.ncmDescricao ? this.dadosForm.ncmDescricao : null
      };
      return dados;
    }
  },
  methods: {
    trocaValorNome(valor, filtro) {
      let resultado;
      if (valor) {
        resultado = filtro.find(f => f.value == valor)
          ? filtro.find(f => f.value == valor).label
          : valor;
      }
      return resultado;
    }
  }
};
</script>

<style lang="scss" scoped>
.resumo-titulo {
  color: var(--branco);
  background: #484848;
  height: 42px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px 10px 0 0;
  border-right: 1px solid var(--preto);
  border-left: 1px solid var(--preto);
  p {
    font-family: "Open Sans", "sans-serif";
    margin: 0;
    font-size: 14px;
    font-weight: 600;
  }
}

.resumo-registro {
  background: #ededed;
  display: flex;
  padding: 0;
  border-radius: 0 0 10px 10px;
}
.bloco1 {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;

  .resumo-descricao {
    overflow: hidden;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      height: 100%;
      width: 100px;
      background: linear-gradient(to right, transparent 0%, #ededed 80%);
      right: 0;
      top: 0;
      z-index: 9 !important;
      border-radius: 0 10px 10px 0;
    }
    padding: 0 20px;
    &:nth-child(odd) {
      border-right: 1px solid #ccc;
    }
  }
}
.resumo {
  max-height: 300px;
  margin-bottom: 10px;
}

.resumo-enter-active,
.resumo-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.resumo-enter,
.resumo-leave-to {
  max-height: 0;
  transform-origin: bottom;
}
</style>
